(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ty-design-system"] && !Shopify.designMode) return;
  try {
    document.addEventListener('shopify:product:select', (event) => {
    const picker = event.target.closest('variant-picker[data-template-product-match="true"]');
    if (!picker || !picker.closest('.product-details') || !event.promise) return;
    event.promise.then(({ detail }) => {
      const id = detail?.resource?.id;
      const formId = document.querySelector('.product-details input[name="id"]')?.value;
      if (!id || String(id) !== formId) return;
      const url = new URL(location.href);
      url.searchParams.set('variant', String(id));
      history.replaceState({}, '', url);
    }).catch(() => {});
  });
  } catch(e) { console.error(e); }
})();

})();
